/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface KinnserOptionalPatientFields
 */
export interface KinnserOptionalPatientFields {
    /**
     * 
     */
    primary_language_key?: string;
    /**
     * 
     */
    zip_plus_4?: string;
    /**
     * 
     */
    other_phone?: string;
    /**
     * 
     */
    cahps_opt_out?: boolean;
    /**
     * 
     */
    representative_first_name?: string;
    /**
     * 
     */
    representative_last_name?: string;
    /**
     * 
     */
    representative_relationship_type_key?: string;
    /**
     * 
     */
    representative_address?: string;
    /**
     * 
     */
    representative_zip?: string;
    /**
     * 
     */
    representative_city?: string;
    /**
     * 
     */
    representative_state?: string;
    /**
     * 
     */
    representative_phone?: string;
    /**
     * 
     */
    representative_email?: string;
    /**
     * 
     */
    representative_language_key?: string;
    /**
     * 
     */
    representative_type_key?: string;
    /**
     * 
     */
    copy_patient_address_to_emergency_contact?: boolean;
    /**
     * 
     */
    emergency_contact_name?: string;
    /**
     * 
     */
    emergency_contact_relationship?: string;
    /**
     * 
     */
    emergency_contact_phone?: string;
    /**
     * 
     */
    emergency_contact_address?: string;
    /**
     * 
     */
    emergency_contact_zip?: string;
    /**
     * 
     */
    emergency_contact_city?: string;
    /**
     * 
     */
    emergency_contact_state?: string;
    /**
     * 
     */
    guarantor_relationship_key?: string;
    /**
     * 
     */
    guarantor_first_name?: string;
    /**
     * 
     */
    guarantor_last_name?: string;
    /**
     * 
     */
    guarantor_address_one?: string;
    /**
     * 
     */
    guarantor_address_two?: string;
    /**
     * 
     */
    guarantor_zip?: string;
    /**
     * 
     */
    guarantor_city?: string;
    /**
     * 
     */
    guarantor_state?: string;
    /**
     * 
     */
    guarantor_phone?: string;
    /**
     * 
     */
    pharmacy_name?: string;
    /**
     * 
     */
    pharmacy_address_one?: string;
    /**
     * 
     */
    pharmacy_address_two?: string;
    /**
     * 
     */
    pharmacy_zip?: string;
    /**
     * 
     */
    pharmacy_city?: string;
    /**
     * 
     */
    pharmacy_state?: string;
    /**
     * 
     */
    pharmacy_phone?: string;
    /**
     * 
     */
    include_in_cjr?: boolean;
    /**
     * 
     */
    patient_source_key?: string;
    /**
     * 
     */
    referral_date?: string;
    /**
     * 
     */
    external_referral_key?: string;
    /**
     * 
     */
    internal_referral_staff_key?: string;
    /**
     * 
     */
    transferred_from_other_hha?: boolean;
    /**
     * 
     */
    face_to_face_date?: string;
    /**
     * 
     */
    supporting_clinical_documentation?: boolean;
    /**
     * 
     */
    face_to_face_comments?: string;
    /**
     * 
     */
    primary_insurance_key?: string;
    /**
     * 
     */
    secondary_insurance_key?: string;
    /**
     * 
     */
    tertiary_insurance_key?: string;
    /**
     * 
     */
    medicare_number?: string;
    /**
     * 
     */
    medicaid_number?: string;
    /**
     * 
     */
    alternate_medicaid_id?: string;
    /**
     * 
     */
    routine_maternity?: boolean;
    /**
     * 
     */
    hospice_care?: boolean;
    /**
     * 
     */
    primary_staff_key?: string;
    /**
     * 
     */
    referring_diagnosis_code?: string;
    /**
     * 
     */
    eligibility_verification?: boolean;
    /**
     * 
     */
    clinical_care_manager_key?: string;
    /**
     * 
     */
    case_manager_key?: string;
    /**
     * 
     */
    oasis_staff_key?: string;
    /**
     * 
     */
    pta_staff_key?: string;
    /**
     * 
     */
    ota_staff_key?: string;
    /**
     * 
     */
    sta_staff_key?: string;
    /**
     * 
     */
    has_secondary_address?: boolean;
    /**
     * 
     */
    has_tertiary_address?: boolean;
    /**
     * 
     */
    has_representative?: boolean;
    /**
     * 
     */
    secondary_address_type_key?: string;
    /**
     * 
     */
    secondary_po_box?: boolean;
    /**
     * 
     */
    secondary_street?: string;
    /**
     * 
     */
    secondary_zip?: string;
    /**
     * 
     */
    secondary_city?: string;
    /**
     * 
     */
    secondary_state?: string;
    /**
     * 
     */
    secondary_time_zone_key?: string;
    /**
     * 
     */
    tertiary_address_type_key?: string;
    /**
     * 
     */
    tertiary_po_box?: boolean;
    /**
     * 
     */
    tertiary_street?: string;
    /**
     * 
     */
    tertiary_zip?: string;
    /**
     * 
     */
    tertiary_city?: string;
    /**
     * 
     */
    tertiary_state?: string;
    /**
     * 
     */
    tertiary_time_zone_key?: string;
    /**
     * 
     */
    associated_physician_keys?: Array<string>;
    /**
     * 
     */
    patient_flag_values?: Array<string>;
    /**
     * 
     */
    apt_room?: string;
    /**
     * 
     */
    other_language?: string;
    /**
     * 
     */
    primary_policy_number?: string;
    /**
     * 
     */
    referring_diagnosis?: string;
    /**
     * 
     */
    representative_other_language?: string;
    /**
     * 
     */
    representative_relationship_other?: string;
    /**
     * 
     */
    secondary_policy_number?: string;
    /**
     * 
     */
    tertiary_policy_number?: string;
    /**
     * 
     */
    transfer_agency_name?: string;
}

/**
 * Check if a given object implements the KinnserOptionalPatientFields interface.
 */
export function instanceOfKinnserOptionalPatientFields(value: object): value is KinnserOptionalPatientFields {
    return true;
}

export function KinnserOptionalPatientFieldsFromJSON(json: any): KinnserOptionalPatientFields {
    return KinnserOptionalPatientFieldsFromJSONTyped(json, false);
}

export function KinnserOptionalPatientFieldsFromJSONTyped(json: any, ignoreDiscriminator: boolean): KinnserOptionalPatientFields {
    if (json == null) {
        return json;
    }
    return {
        
        'primary_language_key': json['primary_language_key'] == null ? undefined : json['primary_language_key'],
        'zip_plus_4': json['zip_plus_4'] == null ? undefined : json['zip_plus_4'],
        'other_phone': json['other_phone'] == null ? undefined : json['other_phone'],
        'cahps_opt_out': json['cahps_opt_out'] == null ? undefined : json['cahps_opt_out'],
        'representative_first_name': json['representative_first_name'] == null ? undefined : json['representative_first_name'],
        'representative_last_name': json['representative_last_name'] == null ? undefined : json['representative_last_name'],
        'representative_relationship_type_key': json['representative_relationship_type_key'] == null ? undefined : json['representative_relationship_type_key'],
        'representative_address': json['representative_address'] == null ? undefined : json['representative_address'],
        'representative_zip': json['representative_zip'] == null ? undefined : json['representative_zip'],
        'representative_city': json['representative_city'] == null ? undefined : json['representative_city'],
        'representative_state': json['representative_state'] == null ? undefined : json['representative_state'],
        'representative_phone': json['representative_phone'] == null ? undefined : json['representative_phone'],
        'representative_email': json['representative_email'] == null ? undefined : json['representative_email'],
        'representative_language_key': json['representative_language_key'] == null ? undefined : json['representative_language_key'],
        'representative_type_key': json['representative_type_key'] == null ? undefined : json['representative_type_key'],
        'copy_patient_address_to_emergency_contact': json['copy_patient_address_to_emergency_contact'] == null ? undefined : json['copy_patient_address_to_emergency_contact'],
        'emergency_contact_name': json['emergency_contact_name'] == null ? undefined : json['emergency_contact_name'],
        'emergency_contact_relationship': json['emergency_contact_relationship'] == null ? undefined : json['emergency_contact_relationship'],
        'emergency_contact_phone': json['emergency_contact_phone'] == null ? undefined : json['emergency_contact_phone'],
        'emergency_contact_address': json['emergency_contact_address'] == null ? undefined : json['emergency_contact_address'],
        'emergency_contact_zip': json['emergency_contact_zip'] == null ? undefined : json['emergency_contact_zip'],
        'emergency_contact_city': json['emergency_contact_city'] == null ? undefined : json['emergency_contact_city'],
        'emergency_contact_state': json['emergency_contact_state'] == null ? undefined : json['emergency_contact_state'],
        'guarantor_relationship_key': json['guarantor_relationship_key'] == null ? undefined : json['guarantor_relationship_key'],
        'guarantor_first_name': json['guarantor_first_name'] == null ? undefined : json['guarantor_first_name'],
        'guarantor_last_name': json['guarantor_last_name'] == null ? undefined : json['guarantor_last_name'],
        'guarantor_address_one': json['guarantor_address_one'] == null ? undefined : json['guarantor_address_one'],
        'guarantor_address_two': json['guarantor_address_two'] == null ? undefined : json['guarantor_address_two'],
        'guarantor_zip': json['guarantor_zip'] == null ? undefined : json['guarantor_zip'],
        'guarantor_city': json['guarantor_city'] == null ? undefined : json['guarantor_city'],
        'guarantor_state': json['guarantor_state'] == null ? undefined : json['guarantor_state'],
        'guarantor_phone': json['guarantor_phone'] == null ? undefined : json['guarantor_phone'],
        'pharmacy_name': json['pharmacy_name'] == null ? undefined : json['pharmacy_name'],
        'pharmacy_address_one': json['pharmacy_address_one'] == null ? undefined : json['pharmacy_address_one'],
        'pharmacy_address_two': json['pharmacy_address_two'] == null ? undefined : json['pharmacy_address_two'],
        'pharmacy_zip': json['pharmacy_zip'] == null ? undefined : json['pharmacy_zip'],
        'pharmacy_city': json['pharmacy_city'] == null ? undefined : json['pharmacy_city'],
        'pharmacy_state': json['pharmacy_state'] == null ? undefined : json['pharmacy_state'],
        'pharmacy_phone': json['pharmacy_phone'] == null ? undefined : json['pharmacy_phone'],
        'include_in_cjr': json['include_in_cjr'] == null ? undefined : json['include_in_cjr'],
        'patient_source_key': json['patient_source_key'] == null ? undefined : json['patient_source_key'],
        'referral_date': json['referral_date'] == null ? undefined : json['referral_date'],
        'external_referral_key': json['external_referral_key'] == null ? undefined : json['external_referral_key'],
        'internal_referral_staff_key': json['internal_referral_staff_key'] == null ? undefined : json['internal_referral_staff_key'],
        'transferred_from_other_hha': json['transferred_from_other_hha'] == null ? undefined : json['transferred_from_other_hha'],
        'face_to_face_date': json['face_to_face_date'] == null ? undefined : json['face_to_face_date'],
        'supporting_clinical_documentation': json['supporting_clinical_documentation'] == null ? undefined : json['supporting_clinical_documentation'],
        'face_to_face_comments': json['face_to_face_comments'] == null ? undefined : json['face_to_face_comments'],
        'primary_insurance_key': json['primary_insurance_key'] == null ? undefined : json['primary_insurance_key'],
        'secondary_insurance_key': json['secondary_insurance_key'] == null ? undefined : json['secondary_insurance_key'],
        'tertiary_insurance_key': json['tertiary_insurance_key'] == null ? undefined : json['tertiary_insurance_key'],
        'medicare_number': json['medicare_number'] == null ? undefined : json['medicare_number'],
        'medicaid_number': json['medicaid_number'] == null ? undefined : json['medicaid_number'],
        'alternate_medicaid_id': json['alternate_medicaid_id'] == null ? undefined : json['alternate_medicaid_id'],
        'routine_maternity': json['routine_maternity'] == null ? undefined : json['routine_maternity'],
        'hospice_care': json['hospice_care'] == null ? undefined : json['hospice_care'],
        'primary_staff_key': json['primary_staff_key'] == null ? undefined : json['primary_staff_key'],
        'referring_diagnosis_code': json['referring_diagnosis_code'] == null ? undefined : json['referring_diagnosis_code'],
        'eligibility_verification': json['eligibility_verification'] == null ? undefined : json['eligibility_verification'],
        'clinical_care_manager_key': json['clinical_care_manager_key'] == null ? undefined : json['clinical_care_manager_key'],
        'case_manager_key': json['case_manager_key'] == null ? undefined : json['case_manager_key'],
        'oasis_staff_key': json['oasis_staff_key'] == null ? undefined : json['oasis_staff_key'],
        'pta_staff_key': json['pta_staff_key'] == null ? undefined : json['pta_staff_key'],
        'ota_staff_key': json['ota_staff_key'] == null ? undefined : json['ota_staff_key'],
        'sta_staff_key': json['sta_staff_key'] == null ? undefined : json['sta_staff_key'],
        'has_secondary_address': json['has_secondary_address'] == null ? undefined : json['has_secondary_address'],
        'has_tertiary_address': json['has_tertiary_address'] == null ? undefined : json['has_tertiary_address'],
        'has_representative': json['has_representative'] == null ? undefined : json['has_representative'],
        'secondary_address_type_key': json['secondary_address_type_key'] == null ? undefined : json['secondary_address_type_key'],
        'secondary_po_box': json['secondary_po_box'] == null ? undefined : json['secondary_po_box'],
        'secondary_street': json['secondary_street'] == null ? undefined : json['secondary_street'],
        'secondary_zip': json['secondary_zip'] == null ? undefined : json['secondary_zip'],
        'secondary_city': json['secondary_city'] == null ? undefined : json['secondary_city'],
        'secondary_state': json['secondary_state'] == null ? undefined : json['secondary_state'],
        'secondary_time_zone_key': json['secondary_time_zone_key'] == null ? undefined : json['secondary_time_zone_key'],
        'tertiary_address_type_key': json['tertiary_address_type_key'] == null ? undefined : json['tertiary_address_type_key'],
        'tertiary_po_box': json['tertiary_po_box'] == null ? undefined : json['tertiary_po_box'],
        'tertiary_street': json['tertiary_street'] == null ? undefined : json['tertiary_street'],
        'tertiary_zip': json['tertiary_zip'] == null ? undefined : json['tertiary_zip'],
        'tertiary_city': json['tertiary_city'] == null ? undefined : json['tertiary_city'],
        'tertiary_state': json['tertiary_state'] == null ? undefined : json['tertiary_state'],
        'tertiary_time_zone_key': json['tertiary_time_zone_key'] == null ? undefined : json['tertiary_time_zone_key'],
        'associated_physician_keys': json['associated_physician_keys'] == null ? undefined : json['associated_physician_keys'],
        'patient_flag_values': json['patient_flag_values'] == null ? undefined : json['patient_flag_values'],
        'apt_room': json['apt_room'] == null ? undefined : json['apt_room'],
        'other_language': json['other_language'] == null ? undefined : json['other_language'],
        'primary_policy_number': json['primary_policy_number'] == null ? undefined : json['primary_policy_number'],
        'referring_diagnosis': json['referring_diagnosis'] == null ? undefined : json['referring_diagnosis'],
        'representative_other_language': json['representative_other_language'] == null ? undefined : json['representative_other_language'],
        'representative_relationship_other': json['representative_relationship_other'] == null ? undefined : json['representative_relationship_other'],
        'secondary_policy_number': json['secondary_policy_number'] == null ? undefined : json['secondary_policy_number'],
        'tertiary_policy_number': json['tertiary_policy_number'] == null ? undefined : json['tertiary_policy_number'],
        'transfer_agency_name': json['transfer_agency_name'] == null ? undefined : json['transfer_agency_name'],
    };
}

export function KinnserOptionalPatientFieldsToJSON(json: any): KinnserOptionalPatientFields {
    return KinnserOptionalPatientFieldsToJSONTyped(json, false);
}

export function KinnserOptionalPatientFieldsToJSONTyped(value?: KinnserOptionalPatientFields | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'primary_language_key': value['primary_language_key'],
        'zip_plus_4': value['zip_plus_4'],
        'other_phone': value['other_phone'],
        'cahps_opt_out': value['cahps_opt_out'],
        'representative_first_name': value['representative_first_name'],
        'representative_last_name': value['representative_last_name'],
        'representative_relationship_type_key': value['representative_relationship_type_key'],
        'representative_address': value['representative_address'],
        'representative_zip': value['representative_zip'],
        'representative_city': value['representative_city'],
        'representative_state': value['representative_state'],
        'representative_phone': value['representative_phone'],
        'representative_email': value['representative_email'],
        'representative_language_key': value['representative_language_key'],
        'representative_type_key': value['representative_type_key'],
        'copy_patient_address_to_emergency_contact': value['copy_patient_address_to_emergency_contact'],
        'emergency_contact_name': value['emergency_contact_name'],
        'emergency_contact_relationship': value['emergency_contact_relationship'],
        'emergency_contact_phone': value['emergency_contact_phone'],
        'emergency_contact_address': value['emergency_contact_address'],
        'emergency_contact_zip': value['emergency_contact_zip'],
        'emergency_contact_city': value['emergency_contact_city'],
        'emergency_contact_state': value['emergency_contact_state'],
        'guarantor_relationship_key': value['guarantor_relationship_key'],
        'guarantor_first_name': value['guarantor_first_name'],
        'guarantor_last_name': value['guarantor_last_name'],
        'guarantor_address_one': value['guarantor_address_one'],
        'guarantor_address_two': value['guarantor_address_two'],
        'guarantor_zip': value['guarantor_zip'],
        'guarantor_city': value['guarantor_city'],
        'guarantor_state': value['guarantor_state'],
        'guarantor_phone': value['guarantor_phone'],
        'pharmacy_name': value['pharmacy_name'],
        'pharmacy_address_one': value['pharmacy_address_one'],
        'pharmacy_address_two': value['pharmacy_address_two'],
        'pharmacy_zip': value['pharmacy_zip'],
        'pharmacy_city': value['pharmacy_city'],
        'pharmacy_state': value['pharmacy_state'],
        'pharmacy_phone': value['pharmacy_phone'],
        'include_in_cjr': value['include_in_cjr'],
        'patient_source_key': value['patient_source_key'],
        'referral_date': value['referral_date'],
        'external_referral_key': value['external_referral_key'],
        'internal_referral_staff_key': value['internal_referral_staff_key'],
        'transferred_from_other_hha': value['transferred_from_other_hha'],
        'face_to_face_date': value['face_to_face_date'],
        'supporting_clinical_documentation': value['supporting_clinical_documentation'],
        'face_to_face_comments': value['face_to_face_comments'],
        'primary_insurance_key': value['primary_insurance_key'],
        'secondary_insurance_key': value['secondary_insurance_key'],
        'tertiary_insurance_key': value['tertiary_insurance_key'],
        'medicare_number': value['medicare_number'],
        'medicaid_number': value['medicaid_number'],
        'alternate_medicaid_id': value['alternate_medicaid_id'],
        'routine_maternity': value['routine_maternity'],
        'hospice_care': value['hospice_care'],
        'primary_staff_key': value['primary_staff_key'],
        'referring_diagnosis_code': value['referring_diagnosis_code'],
        'eligibility_verification': value['eligibility_verification'],
        'clinical_care_manager_key': value['clinical_care_manager_key'],
        'case_manager_key': value['case_manager_key'],
        'oasis_staff_key': value['oasis_staff_key'],
        'pta_staff_key': value['pta_staff_key'],
        'ota_staff_key': value['ota_staff_key'],
        'sta_staff_key': value['sta_staff_key'],
        'has_secondary_address': value['has_secondary_address'],
        'has_tertiary_address': value['has_tertiary_address'],
        'has_representative': value['has_representative'],
        'secondary_address_type_key': value['secondary_address_type_key'],
        'secondary_po_box': value['secondary_po_box'],
        'secondary_street': value['secondary_street'],
        'secondary_zip': value['secondary_zip'],
        'secondary_city': value['secondary_city'],
        'secondary_state': value['secondary_state'],
        'secondary_time_zone_key': value['secondary_time_zone_key'],
        'tertiary_address_type_key': value['tertiary_address_type_key'],
        'tertiary_po_box': value['tertiary_po_box'],
        'tertiary_street': value['tertiary_street'],
        'tertiary_zip': value['tertiary_zip'],
        'tertiary_city': value['tertiary_city'],
        'tertiary_state': value['tertiary_state'],
        'tertiary_time_zone_key': value['tertiary_time_zone_key'],
        'associated_physician_keys': value['associated_physician_keys'],
        'patient_flag_values': value['patient_flag_values'],
        'apt_room': value['apt_room'],
        'other_language': value['other_language'],
        'primary_policy_number': value['primary_policy_number'],
        'referring_diagnosis': value['referring_diagnosis'],
        'representative_other_language': value['representative_other_language'],
        'representative_relationship_other': value['representative_relationship_other'],
        'secondary_policy_number': value['secondary_policy_number'],
        'tertiary_policy_number': value['tertiary_policy_number'],
        'transfer_agency_name': value['transfer_agency_name'],
    };
}

